'use strict';

var CHECKOUT_BREAK_POINT = 872;
var IFRAME_WIDTH = 983;
var CHECKOUT_IMAGE_WIDTH = 336;

exports.CHECKOUT_BREAK_POINT = CHECKOUT_BREAK_POINT;
exports.CHECKOUT_IMAGE_WIDTH = CHECKOUT_IMAGE_WIDTH;
exports.IFRAME_WIDTH = IFRAME_WIDTH;
